var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.label.length
    ? _c(
        "label",
        { staticClass: "flex" },
        [
          _c(
            "span",
            {
              staticClass: "form-input-label",
              class: _vm.disabled ? "disabled" : _vm.labelClasses,
            },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          ),
          _vm.required
            ? _c("span", { staticClass: "form-required ps-1 text-base" }, [
                _vm._v("*"),
              ])
            : _vm._e(),
          _vm.tooltip
            ? _c("svg-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.bottom",
                    value: _vm.tooltip,
                    expression: "tooltip",
                    modifiers: { bottom: true },
                  },
                ],
                staticClass: "form-input-label inline icon-sm ms-2 mt-1",
                class: _vm.disabled ? "disabled" : "",
                attrs: { name: "info-circle" },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }